import { Button } from '@/components/Common';
import { useExamStore } from '@/store/ExamStore/ExamStore';
import { useEpreuve } from './Epreuve.hook';
export const EpreuveFilter = () => {
  const { isOpenExamModal, setIsOpenExamModal } = useExamStore();
  const { selectedDiscipline, epreuveData } = useEpreuve();
  return (
    <div className="flex gap-2 items-center justify-between">
      <div className="flex flex-col">
        <h2 className="text-white text-[32px] font-bold">
          {selectedDiscipline?.name}
        </h2>
        <span className="text-base not-italic font-normal  text-[#616163]">
          {epreuveData?.length} epreuve(s)
        </span>
      </div>

      <div className="flex justify-end w-[30%]">
        <Button title="Ajouter epreuve" onClick={() => setIsOpenExamModal(true)} />
      </div>
    </div>
  );
};
